import React, { FocusEvent } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import { Sort, ActionHandlerFunction, AdminApprovalGroup } from "@preveil-api";
import { CheckboxStates, CheckboxStatesTypes, SupportRoutes, useAppSelector, DriveUIActionTypes, AdminUIActionTypes } from "src/common";
import { Checkbox, Icon, Loading } from "src/components";
import { ListRow } from ".";
import { RootState } from "src/store/configureStore";
import _ from "lodash";


type AllProps = {
  loading: boolean;
  handleAction: ActionHandlerFunction;
  approval_groups: AdminApprovalGroup[];
  sort: Sort<keyof AdminApprovalGroup>;
};

/* Description: List View component for Approval groups */
function ListViewComponent(props: AllProps) {
  const { loading, approval_groups, sort, handleAction } = props;
  const selected = useAppSelector((state: RootState) => state.admin.selected);

  /* Descriptions: Shareable react fragment - for each field returns the header with sort icon
  if applicable */
  function headerWithSortIcon(name: string, field: string) {
    return (
      <>
        {name}
        {!!sort && sort.field === field && approval_groups.length > 1 && (
          <Icon
            className={`${
              sort.direction === "desc" ? "ficon-arrow-down" : "ficon-arrow-up"
            } small-icon ps-1 d-none d-sm-inline`}
          />
        )}
      </>
    );
  }

  // Description: Handles Sorting
  function handleSort(field: string) {
    handleAction({ actionType: DriveUIActionTypes.SetSort, params: field });
  }

  // Description: Get the selected all checkbox state
  function getSelectedState(): CheckboxStatesTypes {
    let ck_state: CheckboxStatesTypes = CheckboxStates.empty;
    ck_state = !selected.length
      ? CheckboxStates.empty
      : selected.length < approval_groups.length
        ? CheckboxStates.indeterminate
        : CheckboxStates.checked;
    return ck_state;
  }

  // Description: Render the rows of Approval Group view
  function RenderList(approval_groups: AdminApprovalGroup[]) {
    return (
      <div className="list-body">
        {_.map(approval_groups, (ag: AdminApprovalGroup, i: number) => {
          return (
            <ListRow
              key={`item_${i}`}
              approval_group={ag}
              selected={selected.includes(ag.approval_group_id)}
              handleAction={handleAction}
            ></ListRow>
          );
        })}
      </div>
    );
  }

  function RenderEmptyView() {
    return <div className="centered-card">
      <Card className="admin-card">
        <Icon className="approval-group-image" />
        <Card.Body>
          <Card.Title as="p">Create your first approval group</Card.Title>
          <Card.Text as="p">
            <span className="text-muted">Learn More:</span>{" "}
            <a target="_blank" href={SupportRoutes.approval_groups} rel="noreferrer">Approval Groups</a>
          </Card.Text>
          <Button onClick={() => handleAction({ actionType: AdminUIActionTypes.SetShow })} variant="primary">
            <Icon className="icon-plus2 text-white" />
            Create Approval Group
          </Button>
        </Card.Body>
      </Card>
    </div>;
  }
 
  return <div className={`admin-list-view approval-groups ${loading ? " isloading" : ""}`}>
    {!!approval_groups && approval_groups.length > 0 && (
      <Row className="header-row">
        <Col md="1">
          <Checkbox
            className="sr-only"
            onChange={(e: FocusEvent<HTMLInputElement>) => handleAction({
              actionType: DriveUIActionTypes.Select,
              params: { selected: e.target.checked },
            })}
            value={getSelectedState()}
            label="Select All"
            selected={getSelectedState()}
          />
        </Col>
        <Col md="4" className="col" onClick={() => handleSort("name")}>{headerWithSortIcon("Name", "name")} </Col>
        <Col md="3" onClick={() => handleSort("approvers")}>{headerWithSortIcon("Approvers", "approvers")}</Col>
        <Col md="3" onClick={() => handleSort("required_approvers")}>{headerWithSortIcon("Required Approvers", "required_approvers")}</Col>
      </Row>
    )}
      {!!approval_groups && approval_groups.length > 0 ? (
        RenderList(approval_groups)
      ) : !loading ? RenderEmptyView() : null}

      {loading && <Loading />}
    </div>;
}

export default React.memo(ListViewComponent);
